import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";

// fetch revenue list
export const fetchRevenueList = async (data: {
  page: number;
  limit: number;
  fromDate?: string;
  toDate?: string;
}) => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };
  // Include optional date filters only if provided
  if (data.fromDate) params.fromDate = data.fromDate;
  if (data.toDate) params.toDate = data.toDate;

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/revenue`,
    params,
  );
  return response;
};
